import type { FavouriteType } from 'src/components/common/FavouriteBtn/types'
import getApiClient from 'src/utils/getApiClient'
import getCSRFToken from 'src/utils/getCSRFToken'

const apiClient = getApiClient()

export default {
  post(type: FavouriteType, id: number) {
    return apiClient.post(`/api/patient/favourites/${type}/${id}/`, {}, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
    })
  },
  delete(type: FavouriteType, id: number) {
    return apiClient.delete(`/api/patient/favourites/${type}/${id}/`, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
    })
  },
  getList(type: FavouriteType, idArray: number[]) {
    return apiClient.post<Array<{ id: number, in_user_favourites: boolean }>>(`/api/patient/favourites/${type}/`, idArray, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
    })
  },
}
